import TimeBar from './time-bar';
import SnapLine from './snap-line';
import Tooltip from './tooltip';
import Legend from './legend';
import ZoomSlider from './zoom-slider';
import EdgeFilterLens from './edge-filter-lens';
import Fisheye from './fisheye';
import MiniMap from './minimap';
import Bundling from './bundling';
import Menu from './menu';

const plugin = {
  TimeBar,
  SnapLine,
  Tooltip,
  Legend,
  ZoomSlider,
  EdgeFilterLens,
  Fisheye,
  MiniMap,
  Bundling,
  Menu,
};
export {
  TimeBar,
  SnapLine,
  Tooltip,
  Legend,
  ZoomSlider,
  EdgeFilterLens,
  Fisheye,
  MiniMap,
  Bundling,
  Menu,
};
export default plugin;
